<template>
  <v-container justify-center pa-3 class="text-center">
    <div v-if="loadingPage">
      <v-progress-linear indeterminate color="accent" height="60"></v-progress-linear>
    </div>
    <div v-else>
      <div class="text-center text-subtitle-1">
        <b>{{ $t('message.no_academy') }}</b>
      </div>
      <div class="text-center mt-2">
        <AcademySelect :label="$t('message.select_academy')" outlined :force-select="true"></AcademySelect>
      </div>
      <v-card-text class="text-center" v-if="!$store.state.inApp">
        <p>{{ $t('message.not_supposed_here') }}</p>
        <div>
          <v-btn color="error" elevation="0" small @click="logout()">
            <v-icon class="mr-1">mdi-logout</v-icon>
            {{ $t("message.logout") }}</v-btn>
        </div>
      </v-card-text>
    </div>
  </v-container>
</template>
<script>
import AcademySelect from "@/components/inputs/AcademySelect.vue";
import Api from "@/services/Api";

export default {
  data() {
    return {
      loadingPage: true,
    };
  },
  created() {
    // 1. If we don't have a token, we shouldn't even be trying to fetch permissions.
    // This stops the 401 loop immediately.
    if (!localStorage.token) {
      console.log('NoAcademy: No token found. Stopping auto-redirect logic.');
      this.$store.dispatch("setSelectedAcademy", null);
      this.$store.dispatch("setManagedAcademy", null);
      this.loadingPage = false;
      return;
    }

    // 2. Only attempt auto-navigation if we have BOTH an academy AND a token
    if (this.$store.state.managedAcademy && this.$store.state.user && this.$store.state.user._id) {
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/admin/" +
          this.$store.state.user._id +
          "/permissions"
        )
        .then((response) => {
          if (response.data.academy && response.data.permissions) {
            this.$store.dispatch("setPermissions", response.data.permissions);
            this.$store.dispatch("setSelectedAcademy", response.data.academy);
            this.navigateTo({ name: "home" });
          } else {
            this.loadingPage = false;
          }
        })
        .catch((err) => {
          // 3. IMPORTANT: If the API fails (401/403), STAY on this page.
          // Do not let an interceptor trigger a reload.
          console.error("NoAcademy: Permission check failed", err);
          this.$store.dispatch("setSelectedAcademy", null);
          this.$store.dispatch("setManagedAcademy", null);
          this.loadingPage = false;
        });
    } else {
      this.$store.dispatch("setSelectedAcademy", null);
      this.$store.dispatch("setManagedAcademy", null);
      this.loadingPage = false;
    }
  },
  components: {
    AcademySelect
  },
  methods: {
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setInApp", false);
      this.$store.dispatch("setSelectedAcademy", null);
      this.$store.dispatch("setManagedAcademy", null);
      this.$store.dispatch("setStripeAccountId", null);
      localStorage.removeItem('vuex');
      localStorage.removeItem('token');
      window.location.replace("/login?to=admin");
    },
  }
}
</script>

<style scoped></style>